module.exports = __webpack_public_path__ + "img/mine_layer_small.6bdf93eb.png";